export function passIf<T = any>(
  condition: any,
  value: T,
): T | undefined {
  if (condition) {
    return value;
  }

  return;
}
